export const systemKo = {
  // LegalPage
  'system.legal.fallbackTitle': '문서',
  'system.legal.fallbackBody': '찾을 수 없습니다.',
  'system.legal.lastUpdated': '{date}에 업데이트됨',

  // NotFoundPage
  'system.notFound.seoTitle': '베일 너머에서 길을 잃다',
  'system.notFound.heading': '지도의 경계를 넘어 방황했습니다',
  'system.notFound.body': '찾던 길은 영원한 황혼에 삼켜졌습니다.',
  'system.notFound.returnCta': '베일로 돌아가기',

  // RouteErrorBoundary
  'system.error.unknownDisturbance': '정체 모를 혼란이 베일을 뒤흔들었습니다.',
  'system.error.seoTitle': '베일의 이상 현상',
  'system.error.heading': '의식이 중단되었습니다',
  'system.error.body':
    '보이지 않는 무언가가 이 페이지를 방해했습니다. 여기는 베일이 얇습니다 — 다시 시도하거나 더 안전한 곳으로 돌아가세요.',
  'system.error.tryAgain': '다시 시도',
  'system.error.returnCta': '베일로 돌아가기',
  'licenseGate.heading': "곧 공개 — 라이선스 제한",
  'licenseGate.body': "이 언어판은 라이선스 문제로 아직 이용할 수 없습니다. 준비 중이니 곧 다시 확인해 주세요.",
} as const
